// extracted by mini-css-extract-plugin
export default {"FooterContainer":"styles_FooterContainer__pIBsR"};